import { lazy, Suspense} from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

const Home  = lazy(() => import('./templates/orange-blue-ce/index'));
const ProgramFlow = lazy(() => import('./templates/programs-flow/'));
const DegreePrograms = lazy(() => import('./templates/degree-programs'));
const CollegeSearch = lazy(() => import("./templates/college-search"));

function App() {

    // let pathname = window.location.pathname;
    // let previousPathname = '';


    const queryParameters = new URLSearchParams(window.location.search);
    // publisher fill in.
    const degree = queryParameters.get("_degree");
    const category = queryParameters.get("_category");
    const subject = queryParameters.get("_subject");
    const classType = queryParameters.get("_class");
    const eduLevel = queryParameters.get("_edlevel");
    const hsGradYear = queryParameters.get("_hsyear");

    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route>
                <Route exact path="/college-finder/*" element={<Home degree={degree} category={category} subject={subject} classType={classType}/>} />
                <Route exact path="/campus-programs/*" element={<ProgramFlow />} />
                <Route path="/degree-programs/*" element={<DegreePrograms/> }/>
                <Route path="/college-search/*" element={<CollegeSearch degree={degree} category={category} subject={subject} eduLevel={eduLevel} hsGradYear={hsGradYear}/>} />
            </Route>
        )
    )

    return (
        <Suspense fallback={<div></div>}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default App;
